// Helpers pra extrair valores tipados de qs.parse (que retorna ParsedQs).
//
// Uso:
//   const query = qs.parse(location.search, { ignoreQueryPrefix: true });
//   const page = qsNumber(query.page, 1);
//   const q = qsString(query.q);

export const qsString = (v: unknown, fallback = ''): string =>
  typeof v === 'string' ? v : fallback;

export const qsNumber = (v: unknown, fallback = 0): number => {
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }
  return fallback;
};
